import React from 'react';
import Header from '../../components/Header';
import ErrorMain from './ErrorMain';
import Footer from '../../components/Footer';


const Error = () => {
  return (
    <>
      <Header/>

      <ErrorMain />

      <Footer/>
    </>
  );
};

export default Error;
